import React from 'react';
import PropTypes from 'prop-types';

import {withTheme} from '@material-ui/core/styles';
import {Card, CardContent, CardHeader, IconButton} from '@material-ui/core';
import {SwapHoriz} from '@material-ui/icons';
//import {MapLegend} from '@geomatico/geocomponents';

/*
const legendFields = [{
  'name': '0 - 5 minutos',
  'type': 'fill',
  'paint': {
    'color': '#00ff002C',
    'outlineColor': '#00cc00',
    'outlineWidth': 2
  }
}, {
  'name': '5 - 10 minutos',
  'type': 'fill',
  'paint': {
    'color': '#ffff002C',
    'outlineColor': '#cccc00',
    'outlineWidth': 2
  }
}, {
  'name': '10 - 15 minutos',
  'type': 'fill',
  'paint': {
    'color': '#ff00002C',
    'outlineColor': '#cc0000',
    'outlineWidth': 2
  }
}];
*/

const Legend = ({icon, modeLabel, onClick/*, theme*/}) => {
  /*
  const legendTypography = {
    ...theme.typography.caption
  };
  */

  return <Card style={{position: 'absolute', bottom: 30, right: 30}}>
    <CardHeader
      avatar={icon}
      title={`${modeLabel}`}
      action={
        <IconButton size='small' onClick={onClick}>
          <SwapHoriz/>
        </IconButton>
      }
    />
    <CardContent style={{padding: '0 0 0 40px'}}>
      {/*<MapLegend fields={legendFields} typographyStyleProps={legendTypography}/>*/}
    </CardContent>
  </Card>;
};

Legend.propTypes = {
  icon: PropTypes.element.isRequired,
  modeLabel: PropTypes.string.isRequired,
  theme: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired
};

export default withTheme(Legend);
